// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__XMdsc","TextLink":"Button_TextLink__Kgrlg"};